import { INetworkClient } from "@/domain/repositories/NetworkClient";
import { IRouteGetKnowledgesByUser } from "@/types/src/backend/routes/knowledges/get-by-user";
import { IDomainAnswers } from "@/types/src/domain/Answers";

export class FormAnswerUsecase {
  constructor(private readonly networkClient: INetworkClient) {}

  async uploadAnswer(answer: any, token: string) {
    const response = await this.networkClient.post("/answers", answer, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    if (response.error) {
      throw new Error(response.error);
    }
  }

  async getAnswers(
    userId: string,
    token: string
  ): Promise<IRouteGetKnowledgesByUser["outputData"]> {
    const response = await this.networkClient.get(
      `/knowledges/user/${userId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    if (response.error) {
      throw new Error(response.error);
    }

    return response.data;
  }
}
